import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import core from "./common/core";
import app from "./common/app";
import config from "./common/config";

let cookie = app.getLoginCookie();
// 2. commented the trans
if (!cookie) {
  let socialId = Date.now();
  app.normalLogin(socialId, (resp) => {
    ReactDOM.render(<App />, document.getElementById("container"));
  });
} else {
  ReactDOM.render(<App />, document.getElementById("container"));
}

core.addClassToElement(
  document,
  "body",
  `si-${config.CURRENT_LANGUAGE.toLocaleLowerCase()}`,
  false
);
config.IS_MOBILE = core.isMobile();
config.IS_TABLET = core.isTablet();

app.disableDocumentEvents();
